<!--服务-->
<template>
  <div class="main">
    <!--    头部-->
    <div class="header">
      <Header
        @toLocation="toLocation"
        :headerMenuSelectedKey="headerMenuSelectedKey"/>
    </div>
    <!--    banner图-->
    <div class="banner">
      <div class="item">
        <img :src="dataList[currentIndex]">
      </div>
      <div class="page" v-if="this.dataList.length > 1">
        <ul>
          <ul>
            <li @click="gotoPrev" class="pre">&lt;</li>
            <li @click="gotoNext" class="next">&gt;</li>
          </ul>
        </ul>
      </div>
    </div>
    <!--    企业微信-->
    <div class="enterpriseWechat">
      <EnterpriseWechat/>
    </div>
    <!--    内容-->
    <div class="content">
      <!--      关于我们-->
      <div class="about-us">
        <h1>我们的服务</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <!--        点击切换-->
        <div class="switch-content">
          <div class="switch-btn-box">
            <div class="switch-btn">
              <button @click="switchBtn(0)" :class="{ newStyle:0===number}">市场营销</button>
            </div>
            <div class="switch-btn">
              <button @click="switchBtn(1)" :class="{ newStyle:1===number}">医学事务</button>
            </div>
            <div class="switch-btn">
              <button @click="switchBtn(2)" :class="{ newStyle:2===number}">研发事务</button>
            </div>
            <div class="switch-btn">
              <button @click="switchBtn(3)" :class="{ newStyle:3===number}">销售事务</button>
            </div>
            <div class="switch-btn">
              <button @click="switchBtn(4)" :class="{ newStyle:4===number}">供应链事务</button>
            </div>
          </div>
          <!--          市场营销内容-->
          <div class="scyx-content" v-show='0===number'>
            <div class="visual-design">
              <div class="visual-design-title">品牌宣传视觉设计</div>
              <div class="visual-design-content">海报设计</div>
              <div class="visual-design-content">产品手册设计</div>
              <div class="visual-design-content">LOGO, VI设计</div>
              <div class="visual-design-content">包装设计</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">PPT美化设计</div>
              <div class="visual-design-content">方案报表设计</div>
              <div class="visual-design-content">市场调研设计</div>
              <div class="visual-design-content">内部宣传PPT设计</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">线下活动策划执行</div>
              <div class="visual-design-content">展会/展台设计</div>
              <div class="visual-design-content">医学会宣传设计</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">社交平台运营</div>
              <div class="visual-design-content">双微运营</div>
              <div class="visual-design-content">抖音策划运营</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">APP设计与开发</div>
              <div class="visual-design-content">UI, UX设计</div>
              <div class="visual-design-content">APP开发与运维</div>
            </div>
          </div>
          <!--          医学事务内容-->
          <div class="scyx-content" v-show='1===number'>
            <div class="visual-design">
              <div class="visual-design-title">医学APP</div>
              <div class="visual-design-content">APP视觉设计</div>
              <div class="visual-design-content">交互设计</div>
              <div class="visual-design-content">开发上线</div>
              <div class="visual-design-content">内容运营</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">患者沟通教育系统</div>
              <div class="visual-design-content">小程序</div>
              <div class="visual-design-content">患者交流反馈系统</div>
              <div class="visual-design-content">积分兑换系统</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">医者赋能平台</div>
              <div class="visual-design-content">科普平台搭建与运营</div>
              <div class="visual-design-content">医生社交IP包装与运营</div>
              <div class="visual-design-content">线上直播</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">公益活动/讲座</div>
              <div class="visual-design-content">策划执行</div>
              <div class="visual-design-content">访谈/义诊交流</div>
              <div class="visual-design-content">患者交流</div>
            </div>
            <div class="visual-design">
              <div class="visual-design-title">视觉可视化设计</div>
              <div class="visual-design-content">PPT美化设计</div>
              <div class="visual-design-content">医学沟通概念可视化</div>
            </div>
          </div>
          <!--          研发事务内容-->
          <div class="scyx-content" v-show='2===number'>
            <div class="visual-design-yfsw">
              <div class="visual-design-title-yfsw">研发流程设计与系统开发</div>
              <div class="visual-design-content-yfsw">样本管理系统设计</div>
              <div class="visual-design-content-yfsw">流程追踪审批系统</div>
              <div class="visual-design-content-yfsw">研发人员权限管理</div>
            </div>
            <div class="visual-design-yfsw">
              <div class="visual-design-title-yfsw">产品原理与效果展示设计</div>
              <div class="visual-design-content-yfsw">海报设计</div>
              <div class="visual-design-content-yfsw">视频创意剪辑</div>
              <div class="visual-design-content-yfsw">三维动画设计</div>
            </div>
            <div class="visual-design-yfsw">
              <div class="visual-design-title-yfsw">内外部宣传设计</div>
              <div class="visual-design-content-yfsw">海报设计</div>
              <div class="visual-design-content-yfsw">墙面设计施工</div>
              <div class="visual-design-content-yfsw">PPT设计</div>
              <div class="visual-design-content-yfsw">视频创意剪辑</div>
            </div>
          </div>
          <!--          销售事务-->
          <div class="scyx-content" v-show='3===number'>
            <div class="visual-design-xssw">
              <div class="visual-design-title-xssw">销售工具可视化设计</div>
              <div class="visual-design-content-xssw">DA设计</div>
              <div class="visual-design-content-xssw">PPT设计</div>
              <div class="visual-design-content-xssw">海报设计</div>
              <div class="visual-design-content-xssw">H5设计</div>
            </div>
            <div class="visual-design-xssw">
              <div class="visual-design-title-xssw">销售工具可视化设计</div>
              <div class="visual-design-content-xssw">CRM系统设计开发</div>
              <div class="visual-design-content-xssw">销售审批系统开发</div>
              <div class="visual-design-content-xssw">销售员/客户管理系统开发</div>
            </div>
            <div class="visual-design-xssw">
              <div class="visual-design-title-xssw">产品舆情监测</div>
              <div class="visual-design-content-xssw">关键字监测</div>
              <div class="visual-design-content-xssw">舆论监测</div>
            </div>
            <div class="visual-design-xssw">
              <div class="visual-design-title-xssw">商机监测与推送</div>
              <div class="visual-design-content-xssw">招投标信息推送</div>
            </div>
          </div>
          <!--          供应链事务-->
          <div class="scyx-content" v-show='4===number'>
            <div class="visual-design-yfsw">
              <div class="visual-design-title-yfsw">EHS材料可视化设计</div>
              <div class="visual-design-content-yfsw">PPT设计</div>
              <div class="visual-design-content-yfsw">工作规范设计</div>
              <div class="visual-design-content-yfsw">培训材料设计</div>
            </div>
            <div class="visual-design-yfsw">
              <div class="visual-design-title-yfsw">生产环境导视系统设计</div>
              <div class="visual-design-content-yfsw">警示标签设计</div>
              <div class="visual-design-content-yfsw">人流动向图设计</div>
              <div class="visual-design-content-yfsw">区域指示标签设计</div>
            </div>
            <div class="visual-design-yfsw">
              <div class="visual-design-title-yfsw">供应链系统/质量/口碑内外宣传设计</div>
              <div class="visual-design-content-yfsw">海报设计</div>
              <div class="visual-design-content-yfsw">公众号图文设计</div>
            </div>
          </div>
        </div>
      </div>
      <!--        相关案例-->
      <div class="representative-box">
        <h1>相关案例</h1>
        <div class="line">
          <div class="line-left"></div>
          <div class="line-right"></div>
        </div>
        <div class="representative">
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/GE-PC.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>GE京东</h3>
                <p>GE京东网站设计与开发—PC端</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/haisen-2.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>海森生物</h3>
                <p>海森生物官方微信设计与维护</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/lvgu.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>绿谷制药</h3>
                <p>绿谷制药节气热点海报</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/ppsj-hssw.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>海森生物LOGO</h3>
                <p>品牌LOGO设计</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/yssj-pa.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>平安好医</h3>
                <p>平安好医宣传演示设计</p>
              </div>
            </a>
          </div>
          <div class="img_div" @click="checkDetails">
            <img src="static/image/solution/spcy-shxyd.jpg" class="img-div-img">
            <a href="#">
              <div class="mask">
                <h3>上海信易贷</h3>
                <p>上海信易贷宣传视频</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!--尾部-->
    <div class="footer">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import EnterpriseWechat from "../components/EnterpriseWechat";

export default {
  components: {Header, Footer, EnterpriseWechat},
  data() {
    return {
      headerMenuSelectedKey: 'service',
      number: 0,
      dataList: ["static/image/service/banner1.jpg", "static/image/service/banner2.jpg",],
      currentIndex: 0,   //默认显示图片
    };
  },
  mounted() {
    document.title = "服务";//todo
    this.gotoPage()
  },
  methods: {
    toLocation(location) {
      this.subMenuSelectedKey = location
      if (location == 'marketingManagement') {
        document.documentElement.scrollTop = 670
        this.number = 0
      } else if (location == 'medicalAffairs') {
        document.documentElement.scrollTop = 670
        this.number = 1
      } else if (location == 'development') {
        document.documentElement.scrollTop = 670
        this.number = 2
      } else if (location == 'salesTransactions') {
        document.documentElement.scrollTop = 670
        this.number = 3
      } else if (location == 'supplyChainTransactions') {
        document.documentElement.scrollTop = 670
        this.number = 4
      }
    },
    //市场营销
    switchBtn(e) {
      this.number = e
    },
    checkDetails() {
      this.$router.push({path: '/CaseDisplay'})
    },
    gotoPrev() {
      this.currentIndex--
    },
    gotoNext() {
      this.currentIndex++;
      if (this.currentIndex == this.dataList.length) {
        this.currentIndex = 0;
      }
    },
    gotoPage() {
      setInterval(() => {
        this.gotoNext()
      }, 3000)
    },
  },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

.main {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(249, 249, 249, 1);
}

.header {
  width: 1920px;
  height: 60px;

}

.enterpriseWechat {
  position: fixed;
  top: 45%;
  right: 0;
}

.banner {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.banner img {
  width: 100%;
  display: block;
}

.banner .page {
  /*background: rgba(0, 0, 0, .5);*/
  color: #ffffff;
  letter-spacing: 20px;
  position: absolute;
  right: 0;
  bottom: 50%;
  width: 100%;
}

.banner .page ul {
  display: flex;
  justify-content: center;
  align-content: center;
}
.pre {
  position: absolute;
  left: 10px;
  font-size: 30px;
}
.next {
  position: absolute;
  right: 0px;
  font-size: 30px;
}

.content {
  width: 1400px;
  height: auto;
}

.about-us {
  width: 100%;
  height: 600px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 50px;
}

h1 {
  color: #D1121C;
  font-size: 34px;
  text-align: center;
}
.line {
  margin-top: 20px;
}

.line-left {
  width: 37px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
}

.line-right {
  width: 119px;
  height: 8px;
  background: #D1121C;
  border-radius: 10px;
  float: left;
  margin-left: 10px;
}

.switch-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.switch-btn-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.switch-btn button {
  width: 205px;
  height: 69px;
  border-radius: 50px;
  /*background: #ECECEC;*/
  font-size: 26px;
  text-align: center;
  line-height: 69px;
  font-weight: bold;
  margin: 50px 0;
  cursor: pointer;
  border: 0;
  float: left;
}

.switch-btn button:hover {
  background: #D1121C;
  color: #FFFFFF;
}

.newStyle {
  width: 205px;
  height: 69px;
  border-radius: 50px;
  font-size: 26px;
  text-align: center;
  line-height: 69px;
  font-weight: bold;
  margin: 50px 0;
  cursor: pointer;
  border: 0;
  background: #D1121C;
  color: #FFFFFF;
}

.scyx-content {
  width: 1400px;
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.visual-design {
  width: 244px;
  height: 275px;
  border-left: 1px solid #D1121C;
}

.visual-design-title {
  width: 242px;
  height: 55px;
  background: #D1121C;
  color: #FFFFFF;
  font-size: 24px;
  line-height: 55px;
  text-align: center;
  margin-bottom: 20px;
}

.visual-design-content {
  width: 226px;
  height: 50px;
  border: 1px solid #838383;
  float: right;
  text-align: center;
  font-size: 20px;
  line-height: 50px;
}

.visual-design-yfsw {
  width: 402px;
  height: 275px;
  border-left: 1px solid #D1121C;
}

.visual-design-title-yfsw {
  width: 402px;
  height: 55px;
  background: #D1121C;
  color: #FFFFFF;
  font-size: 24px;
  line-height: 55px;
  text-align: center;
  margin-bottom: 20px;
}

.visual-design-content-yfsw {
  width: 375px;
  height: 50px;
  border: 1px solid #838383;
  float: right;
  text-align: center;
  font-size: 20px;
  line-height: 50px;
}

.visual-design-xssw {
  width: 306px;
  height: 275px;
  border-left: 1px solid #D1121C;
}

.visual-design-title-xssw {
  width: 306px;
  height: 55px;
  background: #D1121C;
  color: #FFFFFF;
  font-size: 24px;
  line-height: 55px;
  text-align: center;
  margin-bottom: 20px;
}

.visual-design-content-xssw {
  width: 282px;
  height: 50px;
  border: 1px solid #838383;
  float: right;
  text-align: center;
  font-size: 20px;
  line-height: 50px;
}

.representative-box {
  width: 100%;
  height: 1050px;
  margin-bottom: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.representative-box h1 {
  color: #D1121C;
  font-size: 34px;
  text-align: center;
}

.representative {
  width: 100%;
  height: 1000px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 50px;
}

.img_div {
  position: relative;
  width: 450px;
  height: 450px;
}

.img-div-img {
  width: 450px;
  height: 450px;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 450px;
  height: 450px;
  background: rgba(209, 18, 28, 0.8);
  color: #ffffff;
  opacity: 0;
}

.mask h3 {
  font-size: 26px;
  color: #FFFFFF;
  margin-top: 350px;
  margin-left: 20px;
}

.mask p {
  color: #FFFFFF;
  margin-left: 20px;
}

.img_div a:hover .mask {
  transition: 200ms;
  opacity: 1;
}

.footer {
  height: 189px;
  width: 1920px;
  overflow: hidden;
  position: relative;
  bottom: 0;
}


</style>



// WEBPACK FOOTER //
// src/views/Service.vue